import { render, staticRenderFns } from "./CorporationPropertiesView.vue?vue&type=template&id=38bc3451&scoped=true&"
import script from "./CorporationPropertiesView.vue?vue&type=script&lang=js&"
export * from "./CorporationPropertiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc3451",
  null
  
)

export default component.exports